import { useEffect } from 'react';
import { connect } from 'react-redux';

import ERROR from '../../../assets/images/base/cancel.png';
import { Page } from '../../../helbest';

const BankError = ({ Login, history, match }) => {
  const check_user = () => {
    if (!Login.is_login) {
      history.push('/');
    }
  };

  useEffect(() => {
    check_user();
  }, []); //eslint-disable-line

  return (
    <Page
      address="/"
      back={true}
      className="page-bank"
      headerFix
      logo
      mobileContainer
      showFooter
      title="نتیجه پرداخت">
      <div className="container desktop-mode">
        <div className="box-page">
          <div className="text-center">
            <img alt="" className="payment-img" src={ERROR} />
            <h3>پرداخت شما ناموفق بود</h3>
          </div>
          <p>کد پیگـیری سفارش: {match.params.code}</p>
          <div>
            <p>
              متاسفانه پرداخت شما انجام نشد، این اتفاق ممکن است به دلایل مختلفی رخ بدهد، در صورتی که
              از حساب شما مبلغی کسر شده است، طی 72 ساعت آینده به حساب شما برمیگردد.
            </p>
          </div>
          <a className="mt-2 btn btn-block btn-red btn-round line-none" href="tel:+982191008595">
            تماس با پشتیبانی
          </a>
        </div>
      </div>
    </Page>
  );
};

const mstp = (state) => ({
  Login: state.Login,
  Cart: state.Cart
});
export default connect(mstp)(BankError);
